<template>
  <div>
     <v-tabs color="secondary" dark>
      <v-tabs-slider color="white"></v-tabs-slider>
      <v-tab @click="way='payout'">&nbsp; &nbsp;Instant Payout</v-tab>
      <v-tab @click="way='report'">&nbsp; &nbsp;Transaction Report</v-tab>
    </v-tabs>
    <Payout v-show="way === 'payout'" />
    <Report v-show="way === 'report'" />

  </div>
</template>

<script>
import Payout from "../payout/Payout";
import Report  from "../payout/Report";
export default {
  components: { Payout, Report },
  data() {
    return {
      way: "payout"
    }
  },
  mounted() {
    const vm = this;
    if (vm.user.length == 0) {
      vm.$router.push("/account");
    }

    if (!vm.$store.getters.instantpayoutenable) {
      vm.$router.push("/account");
      return;
    }

  }
}
</script>

<style>

</style>